(function(){
  "use strict";

  var BOOKING_URL  = "https://drjerrar.zite.so";
  var WHATSAPP_URL = "https://wa.me/212670675015?text=" + encodeURIComponent("Bonjour, je souhaite prendre rendez-vous au cabinet.");
  document.querySelectorAll(".js-book").forEach(function(a){
    a.href   = BOOKING_URL || WHATSAPP_URL;
    a.target = "_blank";
    a.rel    = "noopener";
  });
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- sticky shrinking nav ---------- */
  var navwrap = document.getElementById("navwrap");
  var lastShrunk = null;
  function onScroll(){
    if (!navwrap) return;
    var s = window.scrollY > 80;
    if (s !== lastShrunk){ navwrap.classList.toggle("shrunk", s); lastShrunk = s; }
    if (!reduce) parallax();
  }

  /* ---------- parallax on blobs ---------- */
  var blobs = Array.prototype.slice.call(document.querySelectorAll(".parallax"));
  var ticking = false;
  function parallax(){
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function(){
      var vh = window.innerHeight;
      blobs.forEach(function(el){
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var d = parseFloat(el.dataset.depth || "0.12");
        var offset = (vh/2 - (r.top + r.height/2)) * d;
        el.style.setProperty("--py", offset.toFixed(1) + "px");
        el.style.transform = (el.classList.contains("team-blob") ? "translateY(-50%) " : "") + "translate3d(0," + offset.toFixed(1) + "px,0)";
      });
      ticking = false;
    });
  }
  window.addEventListener("scroll", onScroll, {passive:true});
  window.addEventListener("resize", onScroll, {passive:true});
  onScroll();

  /* ---------- scroll reveal (staggered) ---------- */
  var rvs = document.querySelectorAll(".rv");
  if ("IntersectionObserver" in window){
    var groups = new Map();
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        var p = e.target.parentElement;
        var n = groups.get(p) || 0;
        groups.set(p, n + 1);
        e.target.style.transitionDelay = Math.min(n, 5) * 80 + "ms";
        e.target.classList.add("in");
        io.unobserve(e.target);
      });
    }, {threshold:0.15, rootMargin:"0px 0px -6% 0px"});
    rvs.forEach(function(el){ io.observe(el); });
  } else {
    rvs.forEach(function(el){ el.classList.add("in"); });
  }

  /* ---------- rails: arrows, drag, snap ---------- */
  document.querySelectorAll("[data-rail]").forEach(function(btn){
    btn.addEventListener("click", function(){
      var rail = document.getElementById(btn.dataset.rail);
      if (!rail) return;
      var card = rail.querySelector(":scope > *");
      var step = card ? card.getBoundingClientRect().width + 22 : rail.clientWidth * 0.8;
      rail.scrollBy({left: step * parseInt(btn.dataset.dir,10), behavior: reduce ? "auto" : "smooth"});
    });
  });

  document.querySelectorAll(".rail").forEach(function(rail){
    var down=false, startX=0, startLeft=0, moved=0;
    rail.addEventListener("pointerdown", function(e){
      if (e.pointerType === "touch") return;
      down=true; moved=0; startX=e.clientX; startLeft=rail.scrollLeft;
      rail.classList.add("dragging");
    });
    rail.addEventListener("pointermove", function(e){
      if (!down) return;
      var dx = e.clientX - startX;
      moved = Math.abs(dx);
      if (moved > 4 && !rail.hasPointerCapture(e.pointerId)) rail.setPointerCapture(e.pointerId);
      rail.scrollLeft = startLeft - dx;
    });
    function end(e){
      if (!down) return;
      down=false;
      rail.classList.remove("dragging");
      if (e && e.pointerId != null && rail.hasPointerCapture(e.pointerId)) rail.releasePointerCapture(e.pointerId);
    }
    rail.addEventListener("pointerup", end);
    rail.addEventListener("pointercancel", end);
    rail.addEventListener("click", function(e){ if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
  });

  /* ---------- testimonials open on the middle card ---------- */
  var tests = document.getElementById("tests");
  if (tests){
    var centerCard = function(){
      var cards = tests.children;
      if (cards.length < 2) return;
      var mid = cards[Math.floor(cards.length/2)];
      tests.scrollLeft = mid.offsetLeft - (tests.clientWidth - mid.clientWidth)/2;
    };
    if (document.readyState === "complete") centerCard();
    else window.addEventListener("load", centerCard);
  }

  /* ---------- disclosure (Voir plus) ---------- */
  document.querySelectorAll(".disclose").forEach(function(btn){
    btn.addEventListener("click", function(){
      var panel = document.getElementById(btn.getAttribute("aria-controls"));
      var open = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", String(!open));
      if (panel) panel.classList.toggle("open", !open);
      btn.querySelector("span").textContent = !open ? btn.dataset.labelOpen : btn.dataset.labelClosed;
    });
  });

  /* ---------- footer accordions ---------- */
  document.querySelectorAll(".flist a.acc").forEach(function(a){
    a.setAttribute("aria-expanded","false");
    a.addEventListener("click", function(e){
      e.preventDefault();
      var sub = a.parentElement.querySelector(".sub");
      var open = a.classList.toggle("open");
      a.setAttribute("aria-expanded", String(open));
      if (sub) sub.classList.toggle("open", open);
    });
  });

  /* ---------- carte du cabinet : Leaflet + tuiles CARTO, repli iframe Google ---------- */
  (function(){
    var el = document.getElementById("leafmap");
    if (!el) return;
    var LAT = 33.5840581, LNG = -7.610473;
    var done = false;

    function fallback(){
      if (done) return; done = true;
      el.innerHTML = '<iframe title="Plan d\'accès au cabinet du Dr Jerrar" loading="lazy" ' +
        'referrerpolicy="no-referrer-when-downgrade" ' +
        'src="https://www.google.com/maps?q=' + LAT + ',' + LNG + '&hl=fr&z=17&output=embed"></iframe>';
    }

    var css = document.createElement("link");
    css.rel = "stylesheet";
    css.href = "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css";
    document.head.appendChild(css);

    var js = document.createElement("script");
    js.src = "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js";
    js.async = true;
    js.onerror = fallback;
    js.onload = function(){
      if (done || typeof L === "undefined") { fallback(); return; }
      try {
        var map = L.map(el, {
          scrollWheelZoom: false,
          zoomControl: true,
          attributionControl: true
        }).setView([LAT, LNG], 16);

        L.tileLayer("https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png", {
          maxZoom: 20,
          attribution: '&copy; OpenStreetMap &copy; CARTO'
        }).addTo(map);

        var pin = L.divIcon({
          className: "tendpin",
          iconSize: [52, 66],
          iconAnchor: [26, 66],
          popupAnchor: [0, -58],
          html: '<svg viewBox="0 0 52 66" width="52" height="66">' +
                '<path d="M26 0C11.6 0 0 11.4 0 25.5 0 44 26 66 26 66s26-22 26-40.5C52 11.4 40.4 0 26 0z" fill="#33504A"/>' +
                '<text x="26" y="34" text-anchor="middle" font-family="Georgia,serif" font-size="24" fill="#EAF1ED">J</text></svg>'
        });

        L.marker([LAT, LNG], { icon: pin, title: "Cabinet du Dr Mohammed Jerrar" })
          .addTo(map)
          .bindPopup("<b>Dr Mohammed Jerrar</b><br>168, rue Hadj Omar Riffi &mdash; 2<sup>e</sup> ét.<br>Casablanca 20120")
          .openPopup();

        map.on("click", function(){ map.scrollWheelZoom.enable(); });
        map.on("mouseout", function(){ map.scrollWheelZoom.disable(); });
        done = true;
      } catch (e) {
        fallback();
      }
    };
    document.head.appendChild(js);

    setTimeout(function(){ if (!done) fallback(); }, 6000);
  })();

  /* ---------- photos manquantes : on masque l'image, le fond pastel reste ---------- */
  document.querySelectorAll("img").forEach(function(img){
    img.addEventListener("error", function(){ img.style.display = "none"; });
    if (img.complete && img.naturalWidth === 0) img.style.display = "none";
  });

  /* ---------- avis video : lecture au scroll, son au clic ---------- */
  document.querySelectorAll(".vid video").forEach(function(v){
    var card = v.closest(".vid"),
        fb   = card.querySelector(".vfb"),
        snd  = card.querySelector(".vsnd"),
        ok   = false;

    function fail(){ if (ok) return; if (fb) fb.hidden = false; if (snd) snd.hidden = true; }
    function ready(){ ok = true; if (snd) snd.hidden = false; if (fb) fb.hidden = true; }
    v.addEventListener("loadeddata", ready);
    if (v.readyState >= 2) ready();
    v.addEventListener("error", fail, true);
    var src = v.querySelector("source");
    if (src) src.addEventListener("error", fail);

    if (snd) snd.addEventListener("click", function(){
      v.muted = !v.muted;
      snd.querySelector("use").setAttribute("href", v.muted ? "#i-mute" : "#i-sound");
      snd.setAttribute("aria-label", v.muted ? "Activer le son" : "Couper le son");
      if (!v.muted) v.play();
    });

    if (!("IntersectionObserver" in window) || reduce) return;
    new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function(){}); }
        else { v.pause(); v.muted = true;
               if (snd) snd.querySelector("use").setAttribute("href", "#i-mute"); }
      });
    }, {threshold:0.4}).observe(v);
  });
})();
